/* 首字母大写 */
export const capitalizeEveryWord = str => str.replace(/\b[a-z]/g, char => char.toUpperCase())

/**
 * 生成下拉数据
 * @param labelProp String
 * @param valueProp String
 * @returns Object 下拉数据
 */
export const generatedOptions = (labelProp = 'label', valueProp = 'value') => originSource => {
  return Object.keys(originSource).map(key => ({
    [labelProp]: key,
    [valueProp]: originSource[key]
  }))
}

// 去除前后空格
export const trim = str => {
  if (Object.prototype.toString.call(str) === '[object String]') {
    return str.trim()
  }
  return str
}

// 是否为对象
export const isObject = value => {
  const type = typeof value
  return value !== null && (type === 'object' || type === 'function')
}

// 是否为数组
export const isArray = value => {
  const _isArray =
    Array.isArray || (_arg => Object.prototype.toString.call(_arg) === '[object Array]')
  return _isArray(value)
}

// 是否为空
export const isEmpty = value => {
  if (value === null || value === undefined || value === '') return true
  if (isObject(value)) return Object.keys(value).length === 0
  if (isArray(value)) return value.length === 0

  return false
}

// 是否为字符串
export const isString = value => {
  return Object.prototype.toString.call(value) === '[object String]'
}

// 是否为数字
export const isNumber = value => {
  return typeof value === 'number' && !isNaN(value)
}

// 下载指定文件
export const downloadFilesUrl = (filePath, fileName) => {
  const baseUrl = filePath
  let xhr = new XMLHttpRequest()
  xhr.open('get', baseUrl, true)
  xhr.responseType = 'blob' // 转换流
  xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('cbaas_system_Token'))
  xhr.onload = function() {
    let blob = this.response
    let a = document.createElement('a')
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = fileName // 文件名
    a.click()
    window.URL.revokeObjectURL(url)
  }
  xhr.send()
}
// 创建文件并下载
export const createFileAndDownload = (fileName, content) => {
  const element = document.createElement('a')
  element.setAttribute(
    'href',
    'data:application/x-yaml;charset=utf-8,' + encodeURIComponent(content)
  )
  element.setAttribute('download', fileName)
  element.style.display = 'none'
  element.click()
}
// 字符串省略号处理
export const textFlow = (value, len) => {
  len = len || 8
  value = value || ''
  let str = value + ''
  if (str.length > len) str = str.substr(0, len) + '...'
  return str
}

export function getUid() {
  return (
    random() +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    '-' +
    random() +
    random() +
    random()
  )
}

function random() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}

export const getRandom = () => {
  return Date.now().toString() + Math.floor(Math.random(1) * 100).toString()
}

export function mergeObjs(def, obj) {
  if (!obj) {
    return def
  } else if (!def) {
    return obj
  }
  for (let i in obj) {
    // 是否是对象
    if (obj[i] != null && obj[i].constructor === Object) {
      def[i] = mergeObjs(def[i], obj[i])
    }
    // 如果是数组, 简单类型可以直接拼接.  对象类型需要递归，继续遍历.
    else if (obj[i] != null && obj[i].constructor === Array && obj[i].length > 0) {
      def[i] = mergeObjs(def[i], obj[i])
    } else {
      def[i] = obj[i]
    }
  }
  return def
}

export function deepClone(initialObj) {
  if (typeof initialObj !== 'object') {
    return initialObj
  }
  let obj = {}
  for (let key in initialObj) {
    if (typeof initialObj[key] === 'object') {
      if (Array.isArray(initialObj[key])) {
        // 数组
        obj[key] = initialObj[key].map(item => deepClone(item))
      } else {
        // 普通对象
        obj[key] = deepClone(initialObj[key])
      }
    } else if (typeof initialObj[key] === 'function') {
      // 方法
      obj[key] = initialObj[key].bind(obj)
    } else {
      // 基本数据类型
      obj[key] = initialObj[key]
    }
  }
  return obj
}

/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
export function debounce(func, wait, immediate) {
  let timer
  return function() {
    let context = this
    let args = arguments

    if (timer) clearTimeout(timer)
    if (immediate) {
      let callNow = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (callNow) func.apply(context, args)
    } else {
      timer = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
}

export function formatFileSize(fileSize) {
  let temp = null
  if (fileSize < 1024) {
    return fileSize + 'B'
  } else if (fileSize < 1024 * 1024) {
    temp = fileSize / 1024
    temp = temp.toFixed(2)
    return temp + 'KB'
  } else if (fileSize < 1024 * 1024 * 1024) {
    temp = fileSize / (1024 * 1024)
    temp = temp.toFixed(2)
    return temp + 'MB'
  } else {
    temp = fileSize / (1024 * 1024 * 1024)
    temp = temp.toFixed(2)
    return temp + 'GB'
  }
}

export function getBaseUrl() {
  let baseUrl =
    window.location.href.indexOf('#') > -1
      ? window.location.href.split('#')[0]
      : window.location.href
  return baseUrl
}

export function getDictLabel(arr, value) {
  if (isEmpty(arr)) {
    return ''
  } else {
    const option = arr.find(item => {
      return item.value === value
    })

    return option ? option.text : ''
  }
}

export function toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

export function hasAuth($store, auth) {
  const allFuncs = $store.state.app.allFuncs
  //不在权限管理集合中的授权，默认通过
  if (!!allFuncs[auth.code]) {
    if (auth.type === 'btns') {
      const btns = $store.state.app.btns
      return !!btns[auth.code]
    } else {
      const menus = $store.state.app.menus
      return !!menus[auth.code]
    }
  } else {
    return true;
  }
}
//时间格式化
export function dateFormat(fmt, date) {
  let ret = ''
  date = new Date(date)
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

//时间格式化 格式化时间戳
export function dateFormatStamp(fmt, date) {
  let ret = ''
  const opt = {
    'Y+': (date.getFullYear() + 100).toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

// 证书名称校验，只能输入小写字母、数字、-字符和.字符，只能以小写字母开头，不允许出现连续的-字符和.字符
export function checkCertificateName(testName) {
  const regex = /^(?![0-9-.])(?!.*?\.\.)[0-9a-z.-]+$/
  const symbolRegA = /(-)\1/
  if (!(regex.test(testName) && !symbolRegA.test(testName))) {
    return '只能输入小写字母、数字、-字符和.字符，只能以小写字母开头，不允许出现连续的-字符和.字符'
  } else {
    return false
  }
}

export default {
  capitalizeEveryWord,
  generatedOptions,
  trim,
  isObject,
  isArray,
  isEmpty,
  isNumber,
  isString,
  downloadFilesUrl,
  createFileAndDownload,
  textFlow,
  getUid,
  mergeObjs,
  deepClone,
  debounce,
  formatFileSize,
  getBaseUrl,
  getDictLabel,
  toThousands,
  hasAuth,
  dateFormat,
  dateFormatStamp,
  checkCertificateName
}
